import { BigHeader, Paragraph } from '@/components/common/Typography';
import { FlexProps } from '@chakra-ui/react';
import { FlexCol } from '../common/Flex';

interface IdvIntroProps extends Omit<FlexProps, 'title'> {
    title: React.ReactNode;
    desc?: React.ReactNode;
}

export default function IdvIntro({ title, desc, ...props }: IdvIntroProps) {
    return (
        <FlexCol mb={{ base: 4, lg: 8, '2xl': 10 }} {...props}>
            <BigHeader mb={desc ? { base: 3, '2xl': 4 } : 0}>{title}</BigHeader>
            {desc && (
                <Paragraph fontSize="md" color="textMuted">
                    {desc}
                </Paragraph>
            )}
        </FlexCol>
    );
}
